import { DOCUMENT, inject, Injectable } from '@angular/core';
import { UtilsService } from '@geekeno/ngx-website/services';
import { environment } from '../../environments/environment';

export interface RazorPayPaymentResponse {
  razorpay_payment_id: string;
  razorpay_order_id: string;
  razorpay_signature: string;
}

export interface RazorPayPaymentFailure {
  error: {
    code: string;
    description: string;
    source: string;
    step: string;
    reason: string;
    metadata: { order_id: string; payment_id: string };
  };
}

@Injectable({
  providedIn: 'root',
})
export class RazorPayService {
  document = inject(DOCUMENT);
  utilService = inject(UtilsService);
  constructor() {
    if (this.utilService.isPlatformBrowser) {
      this.loadScript().then();
    }
  }

  private loadScript() {
    return new Promise<void>((resolve, reject) => {
      const script = this.document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.async = true;
      script.onload = () => {
        resolve();
      };
      script.onerror = () => reject(`Failed to load script: RazorPay Checkout`);
      document.body.appendChild(script);
    });
  }

  collectPayment(
    amountInSubunits: number,
    currency: string,
    description: string,
    orderID: string,
    prefill: { name: string; email: string; contact: string },
    successHandler: (response: RazorPayPaymentResponse) => void,
    errorHandler: (response: RazorPayPaymentFailure) => void,
  ) {
    const options = {
      key: environment.razorpayKey, // Enter the Key ID generated from the Dashboard
      amount: amountInSubunits,
      currency: currency,
      name: 'Geekeno',
      description: description,
      order_id: orderID,
      handler: successHandler,
      prefill: prefill,
      modal: {
        ondismiss: function () {
          errorHandler({
            error: {
              code: 'BAD_REQUEST',
              reason: 'payment_cancelled',
              description: 'User cancelled the payment',
              source: 'api',
              step: 'payment',
              metadata: { order_id: orderID, payment_id: '' },
            },
          });
        },
      },
    };
    // @ts-ignore
    const rzp1 = new window.Razorpay(options);
    rzp1.open();
  }
}
